import axios, { AxiosResponse } from "axios";
import { getItem } from "../hooks/useCookie";

const baseURL = "https://api.ezrak.org/api/v1/";

const mertLocalIP = "https://ezrak.mertgunay.com/api/v1/";

const defaultOptions = {
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
  validateStatus: () => true,
};

let axiosInstance = axios.create(defaultOptions);

const getFormattedResponse = (
  response: AxiosResponse<any>
): AxiosResponse<any> => {
  const { error } = response.data;

  if (error) {
    return {
      ...response,
      data: {
        response: "NOK",
        responseData: error.message,
        error,
      },
    };
  }

  return {
    ...response,
    data: response.data,
  };
};

axiosInstance.interceptors.response.use(
  (config) => {
    const token = getItem("token");

    config.headers.Authorization = token ? `Bearer ${token}` : "";
    return config;
  },
  async (response) => {
    return getFormattedResponse(response);
  }
);

axiosInstance.interceptors.request.use((config) => {
  const token = getItem("token");

  config.headers.Authorization = token ? `Bearer ${token}` : "";
  return config;
});

export default axiosInstance;
